'use client';

import React from 'react';
import { Card, Table, Tag, Typography, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { RoleName } from '@/lib/auth';

const { Title, Text } = Typography;

export default function UsersAdminPage() {
  const users = [
    {
      key: '1',
      username: 'admin',
      name: 'System Administrator',
      email: 'admin@ptxyz.com',
      roles: ['ADMIN'] as RoleName[],
      active: true,
    },
    {
      key: '2',
      username: 'owner',
      name: 'Budi Santoso (Owner)',
      email: 'owner@ptxyz.com',
      roles: ['OWNER'] as RoleName[],
      active: true,
    },
    {
      key: '3',
      username: 'purchaser',
      name: 'Siti Rahma (Purchaser)',
      email: 'purchaser@ptxyz.com',
      roles: ['PURCHASER'] as RoleName[],
      active: true,
    },
    {
      key: '4',
      username: 'warehouse',
      name: 'Agus Wibowo (Warehouse Lead)',
      email: 'warehouse@ptxyz.com',
      roles: ['WAREHOUSE'] as RoleName[],
      active: true,
    },
    {
      key: '5',
      username: 'superops',
      name: 'Rian Perdana (Purchaser & Warehouse)',
      email: 'rian@ptxyz.com',
      roles: ['PURCHASER', 'WAREHOUSE'] as RoleName[], // Directive 5: Many-to-Many
      active: true,
    },
  ];

  const roleColors: Record<RoleName, string> = {
    ADMIN: 'magenta',
    OWNER: 'gold',
    PURCHASER: 'blue',
    WAREHOUSE: 'cyan',
    FINANCE_ADMIN: 'geekblue',
    FINANCE_MANAGER: 'purple',
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>
          User Accounts & Role Assignments
        </Title>
        <Text type="secondary">
          Business Directive 5: Many-to-Many relation between User and Role (1 user can possess multiple roles).
        </Text>
      </div>

      <Card>
        <Table
          dataSource={users}
          pagination={false}
          scroll={{ x: 800 }}
          columns={[
            {
              title: 'User',
              key: 'user',
              render: (_: unknown, u: (typeof users)[0]) => (
                <Space>
                  <UserOutlined style={{ color: '#1677ff' }} />
                  <div>
                    <Text strong>{u.name}</Text>
                    <div style={{ fontSize: 12, color: '#8c8c8c' }}>@{u.username}</div>
                  </div>
                </Space>
              ),
            },
            { title: 'Email', dataIndex: 'email', key: 'email' },
            {
              title: 'Assigned Roles (Many-to-Many)',
              dataIndex: 'roles',
              key: 'roles',
              render: (roles: RoleName[]) => (
                <Space>
                  {roles.map((r) => (
                    <Tag key={r} color={roleColors[r]}>
                      {r}
                    </Tag>
                  ))}
                </Space>
              ),
            },
            {
              title: 'Status',
              dataIndex: 'active',
              key: 'active',
              render: (active: boolean) => (
                <Tag color={active ? 'success' : 'default'}>{active ? 'Active' : 'Inactive'}</Tag>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
}
